import Config from '@configs/Environments';
import useAxios from 'axios-hooks';

// useApi(Config.API_END_POINT);
const path = Config.API_END_POINT + '/entry/relits/';

const useAllListData = (id:string): any => {
    const [{ data, loading, error }] = useAxios(`${path}${id}`, {useCache: false});

    return { data, loading, error };
};

const useOpenRequest = {
    useAllListData,
};

export default useOpenRequest;